import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  FolderIcon,
  getProjects,
  ImportData,
  LinkBtn,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useCanShow,
} from "@";
import MultiSearch from "../components/MultiSearch";
import { excelHeaderCellsName } from "../lib/options";
import { useProjectsPage } from "../hooks/index";
import { DataTable } from "@/shared/components/tanstackTable";

const Page = () => {
  const {
    data,
    columns,
    isLoading,
    error,
    totalItems,
    search,
    updateSearch,
    handleSearchSubmit,
    handleSearchReset,
    pg,
    updatePg,
    refetch,
  } = useProjectsPage();

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "المشاريع", link: "" }]} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التبرعات / المشاريع"
          title="المشاريع"
          count={totalItems}
          icon={FolderIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />

          {useCanShow("editProjects") && (
            <LinkBtn to="/projects/create" create />
          )}

          <DownloadExcel
            fetch={getProjects}
            length={data?.length}
            search={search.values}
            headerCellsName={excelHeaderCellsName}
            logExport={{ action: 0, description: "تصدير المشاريع" }}
          />
          <ImportData success={refetch} to="project" />
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={handleSearchSubmit}
          updateSearch={updateSearch}
          onReset={handleSearchReset}
        />

        {useCanShow("viewProjects") && (
          <DataTable
            data={data}
            columns={columns}
            isLoading={isLoading}
            pagination={{ ...pg, rows: totalItems }}
            onPageChange={(page: number) => updatePg({ page })}
            onPageSizeChange={(size: number) => updatePg({ size, page: 1 })}
          />
        )}
      </main>
    </>
  );
};

export default Page;
